export default {
  path: '/products',
  name: 'products',
  component: () => import('./_views/KernelProducts.vue'),
  meta: {
    title: 'Products',
    navigation: {
      position: 2,
      name: 'Products',
      icon: 'category',
      specialQueries: ['suffix'],
      to: {
        name: 'products',
        query: {
          suffix: '',
          pageNum: '1',
        },
      },
    },
  },
};
